import { SelectedPrice } from '@product/const';
import { StateUtils } from '@spartacus/core';
import { SELECTED_PRICE } from '../product-state';

export const SELECT_PRICE = '[CustomProduct] Select Price';
export const SELECTED_PRICE_RESET = '[CustomProduct] Selected Price Reset';
export const SELECTED_PRICE_ALL_RESET = '[CustomProduct] Selected Price All Reset';

export class SelectPrice extends StateUtils.EntitySuccessAction {
  readonly type = SELECT_PRICE;

  constructor(
    public productCode: string,
    public price: SelectedPrice,
  ) {
    super(SELECTED_PRICE, productCode, price);
  }
}

export class SelectedPriceReset extends StateUtils.EntityLoaderResetAction {
  readonly type = SELECTED_PRICE_RESET;

  constructor(public productCode: string) {
    super(SELECTED_PRICE, productCode);
  }
}
export class SelectedPriceAllReset extends StateUtils.EntityRemoveAllAction {
  readonly type = SELECTED_PRICE_ALL_RESET;

  constructor() {
    super(SELECTED_PRICE);
  }
}
